var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9375 0.6875C10.9375 0.37684 10.6857 0.125 10.375 0.125C10.0643 0.125 9.8125 0.37684 9.8125 0.6875V1.25H4.1875V0.6875C4.1875 0.37684 3.93566 0.125 3.625 0.125C3.31434 0.125 3.0625 0.37684 3.0625 0.6875V1.25H1.375C0.75368 1.25 0.25 1.75368 0.25 2.375V5.1875V13.625C0.25 14.2463 0.75368 14.75 1.375 14.75H12.625C13.2463 14.75 13.75 14.2463 13.75 13.625V5.1875V2.375C13.75 1.75368 13.2463 1.25 12.625 1.25H10.9375V0.6875ZM12.625 4.625V2.375H10.9375V2.9375C10.9375 3.24816 10.6857 3.5 10.375 3.5C10.0643 3.5 9.8125 3.24816 9.8125 2.9375V2.375H4.1875V2.9375C4.1875 3.24816 3.93566 3.5 3.625 3.5C3.31434 3.5 3.0625 3.24816 3.0625 2.9375V2.375H1.375V4.625H12.625ZM1.375 5.75H12.625V13.625H1.375V5.75Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCalendar);
export default __webpack_public_path__ + "static/media/ic_calendar.04aed92e.svg";
export { ForwardRef as ReactComponent };